import { FloatingTooltip } from '../../Floating'
import { IconNG } from '../IconNG'

function IconWithTooltip({ ref, tooltip, tooltipPlacement, ...restProps }) {
  return (
    <FloatingTooltip content={tooltip} placement={tooltipPlacement}>
      <IconNG {...restProps} ref={ref} />
    </FloatingTooltip>
  )
}

export default IconWithTooltip
